import { z } from "zod";

/** App-facing copy is Chinese plus Uyghur. Admin-only labels stay Chinese. */
export const APP_CONTENT_LOCALES = ["zh", "ug"] as const;
export const appContentLocaleSchema = z.enum(APP_CONTENT_LOCALES);
export type AppContentLocale = z.infer<typeof appContentLocaleSchema>;

export function bilingualTitleBodyFields(bodyMax: number) {
  return {
    title: z.string().trim().min(1, "请输入中文标题").max(120),
    titleUg: z.string().trim().min(1, "请输入维吾尔语标题").max(120),
    body: z.string().trim().min(1, "请输入中文正文").max(bodyMax),
    bodyUg: z.string().trim().min(1, "请输入维吾尔语正文").max(bodyMax),
  };
}

export function pickLocaleCopy<T extends { title: string; titleUg: string; body: string; bodyUg: string }>(
  item: T,
  locale: AppContentLocale,
): { title: string; body: string } {
  return locale === "ug" ? { title: item.titleUg, body: item.bodyUg } : { title: item.title, body: item.body };
}
